import { RecipeFields } from 'config/recipes';

import RecipeDiffer from 'domain/recipe/usecases/recipe_differ';

const areRecipesEqual = (recipeA, recipeB) => {
  const recipeDiffer = RecipeDiffer(recipeA);

  for (const key of Object.keys(RecipeFields))
    if (recipeDiffer[key](recipeB[key])) return false;

  return true;
};

export default areRecipesEqual;
